export const MAX_SELECTED_EXPERIMENTS = 10;
